import {getCookie, setCookie} from "cookies-next";

export async function refreshToken() {
    const res = await fetch(`${process.env.NEXT_PUBLIC_API_URL}/refresh-access-token`, {
        method: 'POST',
        headers: {
            'Content-type': 'application/json',
            'Authorization': `Bearer ${getCookie('jwt')}`
        },
        body: JSON.stringify({refresh_token: getCookie('refresh')}),
    });
    const data = await res.json();
    if (data) {
        if (getCookie('refresh')) {
            if (data?.data?.access_token) {
                // setCookie("refresh", data.data);
            } else {
                // window.location.href = '/login'
            }
        } else {
            if (window.location.href !== `${process.env.NEXT_PUBLIC_FE_LOCATION}/login`) {
                // window.location.href = '/login'
            }
        }
    }
    return data;
}